import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { PrivateRoute } from "./privateRoute";
import { HomePage } from "../components/HomePage"
import SigninCallback from "../components/auth/signinResponse";
import { Header } from "../components/header";
import Commission from "../components/Commission";
import { Breadcrumb } from "../components/Breadcrumb";
import { Menu } from "../components/menu/Menu";
import User from "../components/User";
import { ReactNotifications } from "react-notifications-component";
import Escrow from "../components/Escrow";
import Business from "../components/Business";
import Producer from "../components/Producer";
import InvoiceTab from "../components/Invoice/InvoiceTab";
import { PayoutDashboardTab } from "../components/payout-dashboard/PayoutDashboardTab";
import OperatorDashboardTab from "../components/operator-dashboard/OperatorDashboardTab";
import ProducerDashboardTab from "../components/producer-dashboard/ProducerDashboardTab";

export const RoutesOnecomm = (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f4f7f9'
  }}>
    <ReactNotifications />

    <div style={{ height: '84px', flexShrink: 0, zIndex: 1000 }}>
      <Header />
      <Breadcrumb />
    </div>

    <div style={{ display: 'flex', flex: 1, position: 'relative', overflow: 'hidden' }}>

      <div style={{
        width: '200px',
        height: '100%',
        flexShrink: 0,
        borderRight: '1px solid #e0e0e0',
        backgroundColor: '#fcfcfc',
        zIndex: 10
      }}>
        <Menu />
      </div>

      <main style={{
        position: 'relative',
        flex: 1,
        height: '100%',
        width: '100%',
        overflow: 'auto', // C'est ici que la barre de scroll apparaîtra
        padding: '20px',
        boxSizing: 'border-box'
      }}>
        <Routes>
          <Route path="/auth/code" element={<SigninCallback />} />
          <Route path="/" element={<PrivateRoute component={HomePage} rules={['READER','FINANCE','ADMIN']} />} />
          <Route path="/payout-dashboard" element={<PrivateRoute component={PayoutDashboardTab} rules={['READER', 'FINANCE', 'ADMIN']} />} />
          <Route path="/operators-dashboard" element={<PrivateRoute component={OperatorDashboardTab} rules={['READER', 'FINANCE', 'ADMIN']} />} />
          <Route path="/producer-dashboard" element={<PrivateRoute component={ProducerDashboardTab} rules={['READER', 'FINANCE', 'ADMIN']} />} />
          <Route path="/invoice" element={<PrivateRoute component={InvoiceTab} rules={['READER', 'FINANCE', 'ADMIN']} />} />
          <Route path="/escrow" element={<PrivateRoute component={Escrow} rules={['ADMIN']} />} />
          <Route path="/business" element={<PrivateRoute component={Business} rules={['ADMIN']} />} />
          <Route path="/producer" element={<PrivateRoute component={Producer} rules={['READER', 'ADMIN']} />} />
          <Route path="/commission" element={<PrivateRoute component={Commission} rules={['READER', 'ADMIN']} />} />
          <Route path="/user" element={<PrivateRoute component={User} rules={['ADMIN']} />} />
        </Routes>
      </main>
    </div>
  </div>
);